var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import isEqual from 'react-fast-compare';
import { getIn, setIn } from 'formik';
import { deleteIn } from '../../utils/object-utils';
export function formReducer(state, action) {
    switch (action.type) {
        case 'SET_CUSTOM_ERRORS':
            if (isEqual(state.errors, action.payload)) {
                return state;
            }
            return __assign(__assign({}, state), { errors: action.payload });
        case 'SET_CUSTOM_WARNINGS':
            if (isEqual(state.warnings, action.payload)) {
                return state;
            }
            return __assign(__assign({}, state), { warnings: action.payload });
        case 'SET_CUSTOM_FIELD_ERROR': {
            var _a = action.payload, field = _a.field, newError = _a.value;
            var oldError = getIn(state.errors, field);
            if (newError !== oldError) {
                return newError
                    ? __assign(__assign({}, state), { errors: setIn(state.errors, field, newError) }) : __assign(__assign({}, state), { errors: deleteIn(state.errors, field) });
            }
            return state;
        }
        case 'SET_CUSTOM_FIELD_WARNING': {
            var _b = action.payload, field = _b.field, newWarning = _b.value;
            var oldWarning = getIn(state.warnings, field);
            if (newWarning !== oldWarning) {
                return newWarning
                    ? __assign(__assign({}, state), { warnings: setIn(state.warnings, field, newWarning) }) : __assign(__assign({}, state), { warnings: deleteIn(state.warnings, field) });
            }
            return state;
        }
        default:
            return state;
    }
}
export var _initialState = {
    errors: {},
    warnings: {},
};
